import { Navigate, useParams } from 'react-router';

export const RedirectPokedex = () => {
  const { pokemonId } = useParams<{ pokemonId: string }>();
  return <Navigate to={`/pokemons/pokedex/${pokemonId}`} replace />;
};
